import ApiMethods from '../ApiMethods'
import ENDPOINTS from '../Endpoints'

class ConfigApiManager {
    static getBasicParams = () => {
        return ApiMethods.get(ENDPOINTS.BASIC_PARAMS)
    }
}

export default ConfigApiManager
